import BaseAPI from "@/api/BaseAPI";

export class RegionAPI extends BaseAPI {
  constructor() {
    super('/region');
  }

  getRegionsWithScanFiles() {
    return this.http.get(`/withScanFiles`)
  }

  getRegionsWithScanFilesAlt(founderScanType) {
    return this.http.get(`/withScanFilesAlt?founderScanType=${founderScanType}`);
  }

}

export default new RegionAPI()